export enum FileCategoryEnum {
  Other = 0,
  Documents = 1,
  Images = 2,
  Audio = 3,
  Video = 4,
}
